/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import img_Info from "../image/img_Info3.png";

import Footer_FMS from "../2.FMS/Footer_FMS";
import {
  default as Apply_Modal,
  default as Apply_Modal2,
} from "../Component/Apply_Modal";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import Header_Main from "./Header_Main";
import Side_Main from "./Side_Main";
const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 850px;
  justify-self: center;
  @media (max-width: 800px) {
    width: 90%;
  }
`;
const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

function Info() {
  const [stan_modal, set_Stan_Modal] = useState(false);
  const [pre_modal, set_Pre_Modal] = useState(false);
  const close_Stan_Modal = () => set_Stan_Modal(false);
  const close_Pre_Modal = () => set_Pre_Modal(false);
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Main page="회사소개" />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Side_Main />
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                회사소개
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Image src={img_Info} />
            </Main_Content>
          </Main_init_div>
        </Main_div>
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
      <Apply_Modal show={stan_modal} onClose={close_Stan_Modal} data={"stan"} />
      <Apply_Modal2 show={pre_modal} onClose={close_Pre_Modal} data={"pre"} />
    </Container>
  );
}

export default Info;
